import axios from 'axios'
import {APIResponse} from '../../../types/type'
import endpoints from '../../endpoints'
import {TripNumberBase, TripNumberCreatePayload, TripNumberUpdatePayload} from './type'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchTripNumberList(): Promise<APIResponse<TripNumberBase[]>> {
  try {
    const response = await axios.get<APIResponse<TripNumberBase[]>>(
      API_URL + endpoints.tripNumber.list
    )
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createTripNumber(body: TripNumberCreatePayload) {
  try {
    const response = await axios.post(API_URL + endpoints.tripNumber.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateTripNumber(body: TripNumberUpdatePayload) {
  try {
    const response = await axios.post(API_URL + endpoints.tripNumber.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteTripNumber(busId: number) {
  try {
    const response = await axios.get(API_URL + endpoints.tripNumber.delete + busId)
    return response.data
  } catch (error) {
    throw error
  }
}
